import { Component, inject, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { catchError, Subject, takeUntil, tap } from 'rxjs';
import { AppData } from 'src/app/data';
import { _ScheduledFlagStop } from 'src/app/types';
import { GenericRouteEvent } from 'src/app/types/normalize/generic-route-event.model';
import { environment } from 'src/environments/environment';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AddressComponent } from '../address/address.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'route-event-card',
  templateUrl: './route-event-card.component.html',
  styleUrls: ['./route-event-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, IonicModule, AddressComponent, TranslatePipe],
})
export class RouteEventCardComponent implements OnDestroy {
  private readonly _data = inject(AppData);
  private readonly _destroyed$ = new Subject<boolean>();

  @Input() data: GenericRouteEvent = null;
  @Input() preview: boolean = false;
  @Input() headerLevel: number = 2;
  @Input() first: boolean = false;
  @Input() tapForDetails: boolean = true;

  public activelyDriving = false;
  public readonly features = environment.features;

  public readonly onlyFirst =
    (this.data instanceof _ScheduledFlagStop && environment.features.enforceFlagStopSequence) ||
    (!(this.data instanceof _ScheduledFlagStop) && environment.features.onlyAtNextLocationEnabled);

  constructor() {
    this._data.drivingMode$
      .pipe(
        tap(value => (this.activelyDriving = value)),
        catchError(async err => {
          console.error(err);
          this.activelyDriving = false;
        }),
        takeUntil(this._destroyed$),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }
}
